import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type PriceListHistoryEntry = {
  id: string;
  eventType: string;
  occurredOn: string;
  createdByName: string;
  payload: Record<string, unknown>;
};

export const customPriceListHistoryQueryAtom = createQueryAtomFactory(
  'brokerage.customPriceListHistory',
  (params: { id: string }) => ({
    pricingCustomPriceListHistory: {
      __args: { id: params.id },
      id: true,
      eventName: true,
      metadata: {
        occurredOn: true,
      },
      createdByUser: {
        id: true,
        firstName: true,
        lastName: true,
      },
      payload: true,
    },
  }),
  {
    select: (data): PriceListHistoryEntry[] => {
      if (!data?.pricingCustomPriceListHistory) return [];
      return data.pricingCustomPriceListHistory.map((event) => {
        let parsedPayload: Record<string, unknown> = {};
        try {
          parsedPayload =
            typeof event.payload === 'string'
              ? JSON.parse(event.payload)
              : ((event.payload as Record<string, unknown>) ?? {});
        } catch {
          parsedPayload = {};
        }

        const eventType = Object.keys(parsedPayload)[0] ?? event.eventName;

        return {
          id: event.id,
          eventType,
          occurredOn: event.metadata.occurredOn,
          createdByName: event.createdByUser
            ? `${event.createdByUser.firstName ?? ''} ${event.createdByUser.lastName ?? ''}`.trim()
            : 'System',
          payload: parsedPayload,
        };
      });
    },
  },
);
